var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavProfileImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1768_16239",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1768_16239)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#paint0_linear_1768_16239)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0383 16.6422C15.1311 16.2927 14.7688 15.3323 14.7688 15.3323C14.7688 15.3323 14.3601 15.5498 14.3601 14.9389C14.3601 14.3279 14.7688 15.3323 15.1776 12.9733C15.1776 12.9733 16.31 12.667 16.0832 10.1344H15.8107C15.8107 10.1344 16.4919 7.42669 15.8107 6.50869C15.1295 5.59223 14.8586 4.98126 13.3607 4.54386C11.8628 4.10646 12.4086 4.19363 11.3194 4.23838C10.2294 4.28312 9.32217 4.85012 9.32217 5.15638C9.32217 5.15638 8.64094 5.19958 8.37005 5.46186C8.09756 5.72415 7.64394 6.94609 7.64394 7.25158C7.64394 7.55706 7.87075 9.61215 8.09756 10.048L7.82747 10.1359C7.59986 12.6685 8.73311 12.9748 8.73311 12.9748C9.14185 15.3338 9.55059 14.3294 9.55059 14.9404C9.55059 15.5514 9.14185 15.3338 9.14185 15.3338C9.14185 15.3338 8.77959 16.2943 7.87235 16.6437C6.96511 16.9924 1.92879 18.8701 1.51925 19.2635C1.10891 19.6569 1.15539 24 1.15539 24H22.7521C22.7521 24 22.8002 19.6577 22.3898 19.2635C21.9811 18.8701 16.944 16.9924 16.0367 16.6437L16.0383 16.6422Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.0001,
    cy: 12,
    r: 12.4,
    stroke: "#6A6A6A",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1768_16239",
    x1: 2.88151e-8,
    y1: 12.0533,
    x2: 24,
    y2: 12.0533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2968B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27AAE1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavProfileImage);
export default __webpack_public_path__ + "static/media/nav-profile-image.61091a80132aa4412d097f5f31597cbf.svg";
export { ForwardRef as ReactComponent };